import React, { Component, useEffect, useState } from 'react';
import {HashRouter, Redirect, Route, Switch} from 'react-router-dom';
import { withRouter } from 'react-router-dom';
import { SVRoute } from './utils/SVRoute';
import {DEFAULT_ROUTES} from "./utils/RouteConstants";
import { DARK_MODE } from '../constants';
import HeatMapV2 from './HeatMapV2';
import HeatMap from './HeatMap';
import Associate from "./associate/Associate";
import PackageList from "./PackageList";
import {publishCount} from "../MetricUtility";
import StowBuffer from "./stowBuffer/StowBuffer";
import Bay from "./stowBuffer/Bay";
import {DeviceLayoutProvider} from "./common/context/DeviceLayoutContext";
import {ReverseTab} from "@amzn/container-visibility-website";
import {PendingStowList} from "@amzn/container-visibility-website";
import blueDarkTokens from "@amzn/meridian-tokens/theme/blue-dark";
import blueLightTokens from "@amzn/meridian-tokens/theme/blue-light";
import Theme from "@amzn/meridian/theme";
import {
  getDarkModeStatus,
  setDarkModeStateListener,
} from "../handler/ParentDataHandler";

const AppComponent = () => {
    const [currentDarkMode, setCurrentDarkMode] = useState(DARK_MODE.LIGHT);
  
    useEffect(() => {
      setDarkModeStateListener(setCurrentDarkMode);
      getDarkModeStatus();
    }, []);
  
    return (
      <Theme
        tokens={currentDarkMode === DARK_MODE.DARK ? blueDarkTokens : blueLightTokens}
      >
        <DeviceLayoutProvider>
                <HashRouter>
                    <Switch>
                        {Object.keys(DEFAULT_ROUTES).map((path, index) => {
                            return <Route exact path={path} key={index}>
                                <Redirect to={DEFAULT_ROUTES[path]}/>
                            </Route>
                        })}
                        <SVRoute path="/heatMapv2/:routeCodePrefixes" component={HeatMapV2} />
                        <SVRoute path="/heatMapv2" component={HeatMapV2} />
                        <SVRoute path="/heatMap/:routeCodePrefixes" component={HeatMap} />
                        <SVRoute path="/heatMap" component={HeatMap} />
                        <SVRoute path="/associate" component={Associate} />
                        <SVRoute path="/packageList" component={PackageList} />
                        <SVRoute path="/stowBuffer" component={StowBuffer} />
                        <SVRoute path="/bay/:machine" component={Bay} />
                        <SVRoute path="/containerSummary" component={ReverseTab} />
                        <SVRoute path="/pendingStowList" component={PendingStowList}/>
                    </Switch>
                </HashRouter>
            </DeviceLayoutProvider>
      </Theme>
    );
};

class App extends Component {
    componentWillMount() {
        publishRoutePath(this.props.location);
        this.onRouteSwitch = this.props.history.listen(() => {
            publishRoutePath(this.props.location);
        });
    }
    componentWillUnmount() {
        this.onRouteSwitch();
    }

    render() {
        return <AppComponent />;
    }
}

function publishRoutePath(location) {
    const metricProcessName = "SCC_STOW";
    const metricName = location.pathname;
    publishCount(metricProcessName, metricName);
}

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/components/App.js